import React, { ReactElement } from 'react';
import {
  Grid,
  GridColumn,
  GridDataStateChangeEvent,
} from '@progress/kendo-react-grid';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../store';
import '@progress/kendo-theme-bootstrap/dist/all.css';
import { process, State } from '@progress/kendo-data-query';
import { Dispatch } from 'redux';
import { useEffect, useState } from 'react';
import { LocalizationProvider, loadMessages } from '@progress/kendo-react-intl';

import { GetString } from '../StringResourceManager';
import esMessages from '../../utils/gridMessageKey.json';
loadMessages(esMessages, 'fr-CA');
import { locales, LocaleInterface } from '../AlertsGrid/GridLocale';
import { fetchAssetStatePropertiesByNode } from '../../store/Devices/AssetStatesActions';
import { AssetState } from '../../Interfaces/Assets/AssetState';
import { LoadingPanel } from '../LoadingPanel';

interface Props {
  nodeID: number;
  category: string;
}

const NodeAssetCategoryStatusesGrid: React.FC<Props> = ({
  nodeID,
  category,
}): ReactElement => {
  const dispatch: Dispatch<any> = useDispatch();

  const selectedLanguage: string = useSelector(
    (state: ApplicationState) => state.userSettingsReducer.selectedLanguage
  );

  const assetStatusDataState: State = { group: [{ field: 'Category' }] };

  const [dataState, setDataState] = React.useState<State>(assetStatusDataState);

  const [currentLocale, setCurrentLocale] = React.useState<LocaleInterface>(
    locales[0]
  );

  const assetStateProperties: AssetState[] = useSelector(
    (state: ApplicationState) => state.assetStatusesReducer.assetStateProperties
  );

  const loading: boolean = useSelector(
    (state: ApplicationState) =>
      state.assetStatusesReducer.isFetchingAssetStatusesByNode
  );

  useEffect(() => {
    fetchAssetStatePropertiesByNode(dispatch, nodeID);
  }, []);

  useEffect(() => {
    if (selectedLanguage == 'English') {
      setCurrentLocale(locales[0]);
    } else if (selectedLanguage == 'French') {
      setCurrentLocale(locales[1]);
    }
  }, [selectedLanguage]);

  return (
    <LocalizationProvider language={currentLocale.language}>
      {loading && LoadingPanel}
      <Grid
        style={{ height: '650px', width: '700px' }}
        sortable={true}
        filterable={true}
        groupable={true}
        pageable={{
          buttonCount: 4,
          pageSizes: [10, 20, 50, 100, 500],
        }}
        take={100}
        data={process(
          assetStateProperties.filter(asset => asset.Category == category),
          dataState
        )}
        {...dataState}
        onDataStateChange={(e: GridDataStateChangeEvent) => {
          setDataState(e.dataState);
        }}
      >
        <GridColumn
          field="Category"
          title={GetString('COLUMN_TITLE_LANE_CATEGORY')}
          width="200px"
          filterable={false}
        />
        <GridColumn
          field="Name"
          title={GetString('COLUMN_TITLE_LANE_NAME')}
          width="210px"
        />
        <GridColumn
          field="Value"
          title={GetString('COLUMN_TITLE_LANE_VALUE')}
          width="240px"
        />
      </Grid>
    </LocalizationProvider>
  );
};

export default NodeAssetCategoryStatusesGrid;
